import { createResponse, fetchAPI } from "../apiutil";

export const authAPI = {
  login: async (username, password) => {
    console.log("[authAPI.login] attempting login for", username);
    
    // Use URLSearchParams for clean param building
    const params = new URLSearchParams({
      grant_type: 'password',
      client_id: 'web',
      scope: 'api',
      username,
      password
    });
    
    const response = await fetchAPI('/oauth/token', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded',
        'Authorization': 'Basic d2ViOmdsaW1wc2VBUEk='
      },
      body: params.toString()
    });

    if (response.success) {
      console.log("[authAPI.login] Authentication successful!");
      const {data} = response;
      
      return createResponse(true, {
        access_token: data.access_token,
        refresh_token: data.refresh_token,
        expires_in: data.expires_in
      });
    } else {
      console.error("[authAPI.login] Server returned error code:", response.status);
      return response;
    }
  },

  refreshToken: async (refreshToken) => {
    console.log("[authAPI.refreshToken] attempting refresh");
    
    // Use URLSearchParams for clean param building
    const params = new URLSearchParams({
      grant_type: 'refresh_token',
      client_id: 'web',
      scope: 'api',
      refresh_token: refreshToken
    });
    
    const response = await fetchAPI('/oauth/token', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded',
        'Authorization': 'Basic d2ViOmdsaW1wc2VBUEk='
      },
      body: params.toString()
    });
      
    if (response.success) {
      console.log("[authAPI.refreshToken] Refresh successful");
      const {data} = response;
      
      return createResponse(true, {
        access_token: data.access_token,
        refresh_token: data.refresh_token || refreshToken, // Use new token if provided, otherwise keep old one
        expires_in: data.expires_in
      });
    } else {
      console.error("[authAPI.refreshToken] Server returned error code:", response.status);
      return response;
    }
  },

  loadUser: async (accessToken) => {
    return fetchAPI('/api/user', {
      method: 'GET',
      headers: {
        'Authorization': `Bearer ${accessToken}`
      }
    });
  },

  logout: async (accessToken) => {
    return fetchAPI('/api/logout', {
      method: 'GET',
      headers: {
        'Authorization': `Bearer ${accessToken}`
      }
    });
  }
};